{
  "possibleTypes": {
    "AccountQueryPasswordResetTokenValidationResult": [
      "InvalidInputError",
      "NotFoundError",
      "PasswordResetTokenValidationPayload",
      "UnauthorizedError"
    ],
    "AssessmentStep": [
      "DiligenceVisitAssessmentStep",
      "InspectionAssessmentStep",
      "OfferReviewAssessmentStep",
      "VirtualAssessmentStep"
    ],
    "CustomerAccountSellerApplicationResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "CustomerAccountSellerClosingExperienceResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerClosingExperience",
      "UnauthorizedError"
    ],
    "CustomerAccountSellerDisclosureResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerDisclosureReport",
      "UnauthorizedError"
    ],
    "CustomerAccountSellerHomeDetailsResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerHomeDetails",
      "UnauthorizedError"
    ],
    "CustomerAccountSellerOfferRefreshStateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerOfferRefreshState",
      "UnauthorizedError"
    ],
    "Error": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "ExperimentsQueryImpressionsResult": [
      "ExperimentsQueryImpressionsSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "ExperimentsQueryVariantsResult": [
      "ExperimentsQueryVariantsSuccess",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MarketplaceMapSearchResult": [
      "MarketplaceMapSearchClustersResult",
      "MarketplaceMapSearchMarkersResult"
    ],
    "MutationAcceptPartnershipReferralInvitationResult": [
      "InvalidInputError",
      "NotFoundError",
      "ReferralInvitationDecision",
      "UnauthorizedError"
    ],
    "MutationAcceptViewerTermsOfServiceResult": [
      "InvalidInputError",
      "NotFoundError",
      "TermsOfServiceStatus",
      "UnauthorizedError"
    ],
    "MutationAgentOfferDocumentUploadUrlCreateResult": [
      "AgentOfferDocumentUploadUrl",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerFavoriteAddResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerFavoriteRemoveResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerMortgageLeadSubmitResult": [
      "InvalidInputError",
      "MortgageLead",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerPurchaseDocumentDeleteResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerPurchaseDocumentUploadCreateResult": [
      "CreateDocumentUploadPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerPurchaseDocumentUploadUrlCreateResult": [
      "DocumentUploadUrl",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerPurchaseOfferCancelResult": [
      "BuyerPurchaseOfferCancelPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerPurchaseOfferContractRequestResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerPurchaseOfferSubmitResult": [
      "BuyerPurchaseOfferSubmitPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerSavedSearchCreateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SavedSearch",
      "UnauthorizedError"
    ],
    "MutationBuyerSavedSearchDeleteResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerSavedSearchUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SavedSearch",
      "UnauthorizedError"
    ],
    "MutationBuyerTourCancelResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationBuyerTourCreateResult": [
      "InvalidInputError",
      "NotFoundError",
      "TourAppointment",
      "UnauthorizedError"
    ],
    "MutationBuyerTourFeedbackSubmitResult": [
      "InvalidInputError",
      "NotFoundError",
      "TourFeedback",
      "UnauthorizedError"
    ],
    "MutationCancelDocumentUploadResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationChangeViewerPasswordResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationCompleteDocumentUploadResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationCreateAccountWithGeneratedPasswordResult": [
      "AccountSessionPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationCreateAccountWithPasswordResult": [
      "AccountSessionPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationCreateDocumentUploadPartsResult": [
      "CreateDocumentUploadPartsPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationCustomerUpdateResult": [
      "Customer",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationDeclinePartnershipReferralInvitationResult": [
      "InvalidInputError",
      "NotFoundError",
      "ReferralInvitationDecision",
      "UnauthorizedError"
    ],
    "MutationEvaluateExperimentVariantResult": [
      "EvaluateExperimentVariantPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationEvaluateFeatureFlagsResult": [
      "EvaluateFeatureFlagsPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationRegisterViewerPushDeviceResult": [
      "InvalidInputError",
      "NotFoundError",
      "RegisterViewerPushDevicePayload",
      "UnauthorizedError"
    ],
    "MutationRequestPasswordResetResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationRequestPasswordlessOtpResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationResetPasswordWithTokenResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerActiveOfferSignInLinkSendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerAgentListedOfferRequestResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerAgentListedOfferResendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationAddressConfirmResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationAddressUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationAddressVerifyResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationAnswersUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationDocumentDeleteResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationDocumentUploadCreateResult": [
      "CreateDocumentUploadPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationDocumentUploadUrlCreateResult": [
      "DocumentUploadUrl",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationFinalizeResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationPartnerReferralCreateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplicationPartnerReferralCreatePayload",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationResumeLinkSendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationStartResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationStepSubmitResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerApplicationUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerApplication",
      "UnauthorizedError"
    ],
    "MutationSellerCheckoutLinkSendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerCheckoutSubmitResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerDigitalCheckout",
      "UnauthorizedError"
    ],
    "MutationSellerCloseDateChangeRequestResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerClosingDocumentAttachResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerClosingTasksUpdateResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerContractSignatureCompleteResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerContractSignatureEmailSendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerDashboardMarkViewedResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerLead",
      "UnauthorizedError"
    ],
    "MutationSellerDisclosureUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerDisclosureReport",
      "UnauthorizedError"
    ],
    "MutationSellerDueDiligenceAssessmentRescheduleResult": [
      "InvalidInputError",
      "NotFoundError",
      "ScheduledAssessment",
      "UnauthorizedError"
    ],
    "MutationSellerDueDiligenceAssessmentScheduleResult": [
      "InvalidInputError",
      "NotFoundError",
      "ScheduledAssessment",
      "UnauthorizedError"
    ],
    "MutationSellerExpertAssessmentHandoffCancelResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerExpertAssessmentHandoffCancelPayload",
      "UnauthorizedError"
    ],
    "MutationSellerExpertAssessmentHandoffRescheduleResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerExpertAssessmentHandoffReschedulePayload",
      "UnauthorizedError"
    ],
    "MutationSellerExpertAssessmentHandoffScheduleResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerExpertAssessmentHandoffSchedulePayload",
      "UnauthorizedError"
    ],
    "MutationSellerExteriorAssessmentCancelResult": [
      "InvalidInputError",
      "NotFoundError",
      "ScheduledAssessment",
      "UnauthorizedError"
    ],
    "MutationSellerExteriorAssessmentRescheduleResult": [
      "InvalidInputError",
      "NotFoundError",
      "ScheduledAssessment",
      "UnauthorizedError"
    ],
    "MutationSellerExteriorAssessmentScheduleResult": [
      "InvalidInputError",
      "NotFoundError",
      "ScheduledAssessment",
      "UnauthorizedError"
    ],
    "MutationSellerFinalOfferMarkViewedResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerHomeDetailsUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerHomeDetails",
      "UnauthorizedError"
    ],
    "MutationSellerInvitationSendResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerInvitation",
      "UnauthorizedError"
    ],
    "MutationSellerLateCheckoutRequestResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerLeadCommunicationPreferencesUpdateResult": [
      "CommunicationPreferences",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerLeadCustomerPhoneNumberUpdateResult": [
      "Customer",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerLeadUnderwritingSubmitResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerOfferDocumentDeleteResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerOfferDocumentUploadCreateResult": [
      "CreateDocumentUploadPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerOfferDocumentUploadUrlCreateResult": [
      "DocumentUploadUrl",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerOfferFollowupSmsSendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerOfferMarkViewedResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerOfferMarkViewedPayload",
      "UnauthorizedError"
    ],
    "MutationSellerOffersRefreshResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerOffersRefreshPayload",
      "UnauthorizedError"
    ],
    "MutationSellerParticipantInvitationResendResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerParticipantRemoveResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerParticipantRemovePayload",
      "UnauthorizedError"
    ],
    "MutationSellerParticipantsSetResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerParticipantsSetPayload",
      "UnauthorizedError"
    ],
    "MutationSellerPurchaseContractRegenerateResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerSellWithUpsidePricingScenarioAddResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerSellWithUpsidePricingScenarioUpdateResult": [
      "InvalidInputError",
      "NotFoundError",
      "SellerSellWithUpsidePricingScenarioUpdatePayload",
      "UnauthorizedError"
    ],
    "MutationSellerSellingOptionSelectResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerVirtualAssessmentRecordingDeleteResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSellerVirtualAssessmentRecordingSubmitResult": [
      "InvalidInputError",
      "NotFoundError",
      "SelfServeVirtualAssessment",
      "UnauthorizedError"
    ],
    "MutationSellerVirtualAssessmentRecordingsReplaceResult": [
      "InvalidInputError",
      "NotFoundError",
      "SelfServeVirtualAssessment",
      "UnauthorizedError"
    ],
    "MutationSendPasswordlessSignInLinkResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSetViewerCommunicationFeedSubscriptionResult": [
      "InvalidInputError",
      "NotFoundError",
      "SetViewerCommunicationFeedSubscriptionPayload",
      "UnauthorizedError"
    ],
    "MutationSetViewerPrimaryPhoneNumberResult": [
      "Customer",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSignInWithPasswordResult": [
      "AccountSessionPayload",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationSignInWithPasswordlessOtpResult": [
      "InvalidInputError",
      "NotFoundError",
      "SignInWithPasswordlessOtpPayload",
      "UnauthorizedError"
    ],
    "MutationSubmitPartnershipCustomerAttributionResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationTrackExperimentImpressionResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationUnregisterViewerPushDeviceResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationUnsubscribeAddressFromMarketingMailResult": [
      "CommandResult",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "MutationUpdateViewerCommunicationPreferencesResult": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "UpdateViewerCommunicationPreferencesPayload"
    ],
    "SellerActiveOfferAccess": [
      "SellerActiveOfferAccessGranted",
      "SellerActiveOfferSignInRequired"
    ],
    "SellerClosingTaskable": [
      "SellerContractSignatureTask",
      "SellerHoaFeesTask",
      "SellerHvacRoofTask",
      "SellerLateCheckoutTask",
      "SellerOtherHomeInfoTask",
      "SellerServiceAccountsTask",
      "SellerSetCloseDateTask",
      "SellerSetSignatoriesTask"
    ],
    "SellerInContractJourneyStep": [
      "SellerJourneyClosingStep",
      "SellerJourneyRepricingStep"
    ],
    "SellerJourneyStep": [
      "SellerJourneyAssessmentStep",
      "SellerJourneyClosingStep",
      "SellerJourneyContractSigningStep",
      "SellerJourneyRepricingStep",
      "SellerJourneyUnderwritingStep"
    ],
    "SellerPreContractJourneyStep": [
      "SellerJourneyAssessmentStep",
      "SellerJourneyContractSigningStep",
      "SellerJourneyUnderwritingStep"
    ],
    "SellerTransaction": [
      "ClosedTransaction",
      "DeniedTransaction",
      "InContractTransaction",
      "InitializingTransaction",
      "PreContractTransaction",
      "WithdrawnTransaction"
    ],
    "SellerTransactionWithOffer": [
      "ClosedTransaction",
      "InContractTransaction",
      "PreContractTransaction"
    ],
    "SubmitListingOfferResult": [
      "ListingOfferIntakeRejection",
      "ListingOfferSubmitted"
    ],
    "ViewerAssessmentHandoffScheduleResult": [
      "AssessmentHandoffSchedule",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "ViewerAssessmentHandoffSlotsResult": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "ViewerAssessmentHandoffSlotsSuccess"
    ],
    "ViewerHomeGuideComparablesResult": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "ViewerHomeGuideComparablesSuccess"
    ],
    "ViewerHomeGuideDetailsResult": [
      "HomeGuideDetails",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "ViewerHomeGuideMarketMetricsResult": [
      "HomeGuideMarketMetrics",
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError"
    ],
    "ViewerHomeGuidePricingComparablesResult": [
      "InvalidInputError",
      "NotFoundError",
      "UnauthorizedError",
      "ViewerHomeGuidePricingComparablesSuccess"
    ]
  }
}